import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElementType,
  updateSelectedInteraction,
  updateSelectedTakeSequence,
} from "../../app/slices/TrainingSlice";
import { ISequence } from "../../models/interactions/Sequence";

export function useUpdateActiveSequence() {
  const dispatch = useDispatch();
  const selectedElementType = useSelector(selectSelectedElementType);

  const updateSequence = useCallback(
    (canvasSequence: ISequence) => {
      // Canvas nodes carry React Flow's live drag flag. An Alt-drag used to save
      // `dragging: true`, and React Flow pulls a dragging node into every marquee.
      const sequence = {
        ...canvasSequence,
        nodes: canvasSequence.nodes?.map(({ dragging: _dragging, ...node }) => node),
      };
      if (selectedElementType === "takeSequence") {
        dispatch(updateSelectedTakeSequence(sequence));
        return;
      }

      dispatch(updateSelectedInteraction(sequence));
    },
    [dispatch, selectedElementType]
  );

  return { updateSequence };
}
